import React from 'react';
import PropTypes from 'prop-types';
import FlightHeader from '../../../components/review/flightHeader/FlightHeader';
import Dictionary from '../../../model/Dictionary';
import PassengerInfo from '../../../components/review/passengerInfo/PassengerInfo';
import './ReviewFlight.css';

const ReviewFlight = ({ flight, toggleMealDetails, showMealDetails }) => (
  <div className='review-flight'>
    <FlightHeader
      flightId={flight.id}
      from={flight.from}
      to={flight.to}
      date={flight.date}
      departTime={flight.departTime}
      arriveTime={flight.arriveTime}
    />
    <div className='flight-passengers-wrapper'>
      <div className='flight-passengers'>
        {!flight.passengers || !flight.passengers.length ?
          Dictionary.passengers.noPassengers :
          flight.passengers.map((passenger, index) => (
            <PassengerInfo
              key={`flight-review-passenger-${flight.id}-${passenger.id}-${index}`}
              passengerNum={index + 1}
              passenger={passenger}
              seat={passenger.seatPreview}
              meals={flight.meals}
              toggleMealDetails={toggleMealDetails}
              showMealDetails={showMealDetails}
            />
          ))}
      </div>
    </div>
  </div>
);

ReviewFlight.propTypes = {
  flight: PropTypes.object,
  toggleMealDetails: PropTypes.func,
  showMealDetails: PropTypes.string,
};

export default ReviewFlight;



// WEBPACK FOOTER //
// ./src/containers/review/reviewFlight/ReviewFlight.js